'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _util = require('./util');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWindow = require('react-window');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuList = function (_React$PureComponent) {
  _inherits(MenuList, _React$PureComponent);

  function MenuList(props) {
    _classCallCheck(this, MenuList);

    var _this = _possibleConstructorReturn(this, _React$PureComponent.call(this, props));

    _this.setListRef = _this.setListRef.bind(_this);
    _this.getItemSize = _this.getItemSize.bind(_this);

    _this.state = {
      currentIndex: 0,
      children: null,
      heights: [],
      itemCount: 0,
      menuHeight: 0
    };
    return _this;
  }

  MenuList.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.children !== prevState.children) {
      var getStyles = nextProps.getStyles;

      var children = _react2.default.Children.toArray(nextProps.children);

      var head = children[0] || {};
      var _head$props = head.props;
      _head$props = _head$props === undefined ? {} : _head$props;
      var _head$props$data = _head$props.data;
      _head$props$data = _head$props$data === undefined ? {} : _head$props$data;
      var _head$props$data$opti = _head$props$data.options,
          options = _head$props$data$opti === undefined ? [] : _head$props$data$opti;

      var groupedChildrenLength = options.length;
      var isGrouped = groupedChildrenLength > 0;
      var flattenedChildren = isGrouped && (0, _util.flattenGroupedChildren)(children);

      children = isGrouped ? flattenedChildren : children;

      var groupHeadingStyles = getStyles('groupHeading', nextProps);
      var loadingMsgStyles = getStyles('loadingMessage', nextProps);
      var noOptionsMsgStyles = getStyles('noOptionsMessage', nextProps);
      var optionStyles = getStyles('option', nextProps);
      var getHeight = (0, _util.createGetHeight)({
        groupHeadingStyles: groupHeadingStyles,
        noOptionsMsgStyles: noOptionsMsgStyles,
        optionStyles: optionStyles,
        loadingMsgStyles: loadingMsgStyles
      });

      var heights = children.map(getHeight);

      var currentIndex = (0, _util.getCurrentIndex)(children);

      var itemCount = children.length;

      // calc menu height
      var sum = function sum(a, b) {
        return a + b;
      };

      var _getStyles = getStyles('menuList', nextProps),
          maxHeight = _getStyles.maxHeight,
          _getStyles$paddingBot = _getStyles.paddingBottom,
          paddingBottom = _getStyles$paddingBot === undefined ? 0 : _getStyles$paddingBot,
          _getStyles$paddingTop = _getStyles.paddingTop,
          paddingTop = _getStyles$paddingTop === undefined ? 0 : _getStyles$paddingTop;

      var totalHeight = heights.reduce(sum, 0);
      var totalMenuHeight = totalHeight + paddingBottom + paddingTop;
      var menuHeight = Math.min(maxHeight, totalMenuHeight);
      var estimatedItemSize = Math.floor(totalHeight / itemCount);

      return {
        children: children,
        currentIndex: currentIndex,
        estimatedItemSize: estimatedItemSize,
        heights: heights,
        itemCount: itemCount,
        menuHeight: menuHeight
      };
    }

    return null;
  };

  MenuList.prototype.componentDidUpdate = function componentDidUpdate() {
    var currentIndex = this.state.currentIndex;


    if (this.state.children.length === 1) {
      this.list.resetAfterIndex(0);
    }

    /**
     * enables scrolling on key down arrow
     *
     * note: prevents scrolling on index 0 to avoid
     * returning to top of menu when it remains open after selecting
     */
    if (currentIndex >= 1) {
      this.list.scrollToItem(currentIndex);
    }
  };

  MenuList.prototype.getItemSize = function getItemSize(index) {
    return this.state.heights[index];
  };

  MenuList.prototype.setListRef = function setListRef(ref) {
    this.list = ref;
  };

  MenuList.prototype.render = function render() {
    var _props = this.props,
        getStyles = _props.getStyles,
        innerRef = _props.innerRef,
        selectProps = _props.selectProps;
    var _state = this.state,
        stateChildren = _state.children,
        estimatedItemSize = _state.estimatedItemSize,
        menuHeight = _state.menuHeight,
        itemCount = _state.itemCount;

    var _getStyles2 = getStyles('menuList', this.props),
        maxHeight = _getStyles2.maxHeight,
        paddingTop = _getStyles2.paddingTop,
        paddingBottom = _getStyles2.paddingBottom,
        menuListStyle = _objectWithoutProperties(_getStyles2, ['maxHeight', 'paddingTop', 'paddingBottom']);

    var _ref = selectProps || {},
        classNamePrefix = _ref.classNamePrefix,
        isMulti = _ref.isMulti;

    return _react2.default.createElement(
      _reactWindow.VariableSizeList,
      {
        className: classNamePrefix ? classNamePrefix + '__menu-list' + (isMulti ? ' ' + classNamePrefix + '__menu-list--is-multi' : '') : '',
        style: menuListStyle,
        ref: this.setListRef,
        outerRef: innerRef,
        estimatedItemSize: estimatedItemSize,
        innerElementType: (0, _react.forwardRef)(function (_ref2, ref) {
          var style = _ref2.style,
              rest = _objectWithoutProperties(_ref2, ['style']);

          return _react2.default.createElement('div', _extends({
            ref: ref,
            style: _extends({}, style, {
              height: parseFloat(style.height) + paddingBottom + paddingTop + 'px'
            })
          }, rest));
        }),
        height: menuHeight,
        itemCount: itemCount,
        itemData: stateChildren,
        itemSize: this.getItemSize
      },
      function (_ref3) {
        var data = _ref3.data,
            index = _ref3.index,
            style = _ref3.style;

        return _react2.default.createElement(
          'div',
          {
            style: _extends({}, style, {
              top: parseFloat(style.top) + paddingTop + 'px'
            })
          },
          data[index]
        );
      }
    );
  };

  return MenuList;
}(_react2.default.PureComponent);

MenuList.propTypes = process.env.NODE_ENV !== "production" ? {
  getStyles: _propTypes2.default.func,
  getValue: _propTypes2.default.func,
  options: _propTypes2.default.array
} : {};

exports.default = MenuList;
module.exports = exports['default'];